import React, { useState } from "react";
import PropTypes from "prop-types";
import { ShoppingBag } from "react-feather";
import i18n from "~/assets/js/Helpers/i18n";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import Avatar from "./Avatar";
import ImageButton from "../Button/ImageButton";
import HeaderSideMenu from "./HeaderSideMenu";
import headerMenuLinks from "./HeaderMenuLinks";
import CheckoutSession from "../../pages/Checkout/CheckoutSession";
import { PAGES } from "../../pages/Checkout/CheckoutProvider";
import cartSession from "../../global/cartSession";
import {
    applyMenuItemFilter,
    applyNoReusableBowlsFilter,
} from "~/assets/js/Helpers/reusable-bowls-utils";
import ConfiguratorLinkButton, {
    ConfiguratorLinkContent,
    ConfiguratorScroller,
} from "./ConfiguratorLink";
import { useFeatureFlagVariantKey } from "posthog-js/react";

const Header = () => {
    const { isDesktop } = useViewport();

    const handleToCheckout = () => {
        const session = CheckoutSession.init(CheckoutSession.initialState);
        session.page = PAGES.CART;
        CheckoutSession.update(session);
        location.href = "/warenkorb/";
    };

    return isDesktop ? (
        <DesktopFullHeader toCheckout={handleToCheckout} />
    ) : (
        <MobileFullHeader toCheckout={handleToCheckout} />
    );
};

const DesktopFullHeader = ({ toCheckout }) => {
    const { topMenu, bottomMenu } = headerMenuLinks;

    const configuratorLinks = [
        // {
        //     name: "Deine Bowl",
        //     image: "/wp-content/plugins/pottsalat/static/images/bowl.webp",
        //     link: "/meine-bowl",
        // },
        // {
        //     name: "Dein Potti",
        //     image: "/wp-content/plugins/pottsalat/static/images/potti.webp",
        //     link: "/mein-potti",
        // },
        // {
        //     name: "Deine Ramen",
        //     image: "/wp-content/plugins/pottsalat/static/images/ramen.webp",
        //     link: "/meine-ramen",
        // },
    ];
    // const isConfiguratorTextTest =
    //     useFeatureFlagVariantKey("your-salad") === "test";
    // if (isConfiguratorTextTest) {
    //     configuratorLinks[1].name = "Dein Salat";
    // }

    return (
        <header id="desktop-full-header">
            <div className="container" style={{ display: "flex" }}>
                <div className="logo-wrapper">
                    <a href="/">
                        {reactConfig.logoUrl && (
                            <img
                                id="pottsalat-logo"
                                src={reactConfig.logoUrl}
                                alt="pottsalat-logo"
                                height={50}
                                width={100}
                            />
                        )}
                    </a>
                </div>
                <div className="content-wrapper">
                    <div className="upper">
                        <div className="upper__menu">
                            {topMenu.map((link) => {
                                return (
                                    <a
                                        key={link.content}
                                        className="upper__menu__link "
                                        href={link.href}>
                                        {link.content}
                                    </a>
                                );
                            })}
                        </div>
                        <div className="login-wrapper">
                            <Avatar />
                        </div>
                    </div>
                    {/* <div className="lower">
                        <div className="lower__menu">
                            {bottomMenu.map((link) => {
                                return (
                                    <a
                                        key={link.content}
                                        className="lower__menu__link "
                                        href={link.href}>
                                        {link.content}
                                    </a>
                                );
                            })}
                        </div>
                        <div className="lower__buttons">
                            <div className="configurator-container">
                                <a
                                    href={
                                        configuratorLinks[0]?.link +
                                        "?source=navbar"
                                    }
                                    className="configurator-button">
                                    <div className="configurator-switch">
                                        <ConfiguratorScroller
                                            configuratorLinks={
                                                configuratorLinks
                                            }
                                        />
                                        <ConfiguratorLinkContent
                                            category={configuratorLinks[0]}
                                        />
                                    </div>
                                </a>
                                <div className="dropdown-content">
                                    {configuratorLinks
                                        .slice(1, configuratorLinks.length)
                                        .map((category, index) => {
                                            return (
                                                <a
                                                    key={index}
                                                    href={
                                                        category.link +
                                                        "?source=navbar"
                                                    }
                                                    className="configurator-button">
                                                    <ConfiguratorLinkContent
                                                        category={category}
                                                    />
                                                </a>
                                            );
                                        })}
                                </div>
                            </div>
                            <div className="basket-wrapper">
                                <div className="basket" onClick={toCheckout}>
                                    <ShoppingBag />
                                    <ProductsInCartBubble />
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </header>
    );
};

const MobileFullHeader = ({ toCheckout }) => {
    const [open, setOpen] = useState(false);
    const burgerIcon = !open ? "fa-bars" : "fa-times";

    const HeaderSideMenuConfig = {
        open: open,
        handleClose: () => {
            setOpen(false);
        },
    };

    return (
        <>
            <HeaderSideMenu {...HeaderSideMenuConfig} />
            <header id="header" style={{ minHeight: "84px" }}>
                <div className="cart-header">
                    <a href="/">
                        {reactConfig.logoUrl && (
                            <img
                                id="pottsalat-logo"
                                src={reactConfig.logoUrl}
                                alt="pottsalat-logo"
                                height={50}
                                width={100}
                            />
                        )}
                    </a>
                    <div className="header-right">
                        <div
                            onClick={() => setOpen(!open)}
                            className="header-right__item menu"
                        >
                            <i
                                className={`fas ${burgerIcon}`}
                                style={{ marginRight: "8px" }}
                            ></i>
                            {i18n.t("header.menu")}
                        </div>
                        {/* <div
                            className="header-right__item"
                            onClick={toCheckout}
                        >
                            <ShoppingBag />
                            <ProductsInCartBubble />
                        </div> */}
                    </div>
                </div>
            </header>
        </>
    );
};

const ProductsInCartBubble = () => {
    let numberOfItemsInCart = 0;
    if (cartSession.isSet()) {
        const cartItems = cartSession?.get()?.items;
        numberOfItemsInCart =
            cartItems
                ?.filter(applyNoReusableBowlsFilter)
                ?.filter(applyMenuItemFilter)
                ?.reduce((total, item) => total + item.quantity, 0) || 0;
    }

    return <span id="product-count-bubble">{numberOfItemsInCart}</span>;
};

const HeaderProps = {
    toCheckout: PropTypes.func.isRequired,
};

MobileFullHeader.propTypes = HeaderProps;
DesktopFullHeader.propTypes = HeaderProps;

export default Header;
